import { Controller } from "stimulus"

export default class extends Controller {
  static values = { selected: Boolean }
  static targets = [ "label", "radio", "name", "description" ]

  select(event) {
    this.selectedValue = true
  }

  selectedValueChanged() {
    this.radioTarget.checked = this.selectedValue

    // Label
    this.element.classList.toggle("bg-indigo-50", this.isChecked)
    this.element.classList.toggle("border-indigo-200", this.isChecked)
    this.element.classList.toggle("z-10", this.isChecked)
    this.element.classList.toggle("border-gray-200", !this.isChecked)

    // Name
    this.nameTarget.classList.toggle("text-indigo-900", this.isChecked)
    this.nameTarget.classList.toggle("text-gray-900", !this.isChecked)

    // Description
    this.descriptionTarget.classList.toggle("text-indigo-700", this.isChecked)
    this.descriptionTarget.classList.toggle("text-gray-500", !this.isChecked)
  }

  get isChecked() {
    return this.radioTarget.checked
  }
}
